
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/take-a-break",
      function () {
        return require("private-next-pages/settings/take-a-break.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/take-a-break"])
      });
    }
  